import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'FaqChat',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var _useIsFaq = useIsFaq(),
      isFaqPage = _useIsFaq.isFaqPage;
    var _useNuxt2App = useNuxt2App(),
      locale = _useNuxt2App.i18n.locale;
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadBotmind();
          case 2:
            open();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var opened = ref(false);
    function loadBotmind() {
      return _loadBotmind.apply(this, arguments);
    }
    function _loadBotmind() {
      _loadBotmind = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (document.getElementById('botmind-iframe')) {
                document.getElementById('botmind-iframe').outerHTML = '';
              }
              if (document.getElementById('faqBotmindChatScript')) {
                document.getElementById('faqBotmindChatScript').outerHTML = '';
              }
              return _context2.abrupt("return", new Promise(function (resolve) {
                var scriptWidget = document.createElement('script');
                scriptWidget.src = 'https://widget.botmind.ai/public/widget.js';
                scriptWidget.id = 'faqBotmindChatScript';
                scriptWidget.async = false;
                document.head.append(scriptWidget);
                scriptWidget.onload = function () {
                  resolve(true);
                };
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _loadBotmind.apply(this, arguments);
    }
    function open() {
      return _open.apply(this, arguments);
    }
    function _open() {
      _open = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var mode;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              opened.value = true;
              if (document.getElementById('faqBotmindChatScript')) {
                _context3.next = 4;
                break;
              }
              _context3.next = 4;
              return loadBotmind();
            case 4:
              mode = isFaqPage.value ? {
                startWithWidgetOpen: true,
                contactFormMode: false,
                freeDivMode: 'faq-page-with-chat'
              } : {
                startWithWidgetOpen: false,
                setWidgetOnLeftSide: true
              };
              if (window.botmindWidget.works && window.botmindWidget.init) {
                window.botmindWidget.init({
                  token: process.env.BOTMIND_CHAT_TOKEN,
                  host: 'https://api.widget.botmind.ai',
                  language: locale
                }, undefined, mode);
              }
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _open.apply(this, arguments);
    }
    expose({
      open: open
    });
    return {
      __sfc: true,
      isFaqPage: isFaqPage,
      locale: locale,
      opened: opened,
      loadBotmind: loadBotmind,
      open: open
    };
  }
});